module.exports = __webpack_public_path__ + "assets/media/search_icon.485bcc54.svg";